// Brand assets + external links — single source of truth
export const ASSETS = {
  paulaCharacter:
    "https://customer-assets.emergentagent.com/job_paula-landing/artifacts/j435pvyf_RSPP.jpg",
  plushPaula:
    "https://customer-assets.emergentagent.com/job_paula-landing/artifacts/4w6pdg17_IMG_20260610_142918.jpg",
  anmalPaula3d:
    "https://customer-assets.emergentagent.com/job_paula-landing/artifacts/ihhrd8vv_IMG_20251029_075600.jpg",
  anmalPaulaBlank:
    "https://customer-assets.emergentagent.com/job_paula-landing/artifacts/f69hp9ge_IMG_20251029_075600.jpg",
  anmalPaulaProgress:
    "https://customer-assets.emergentagent.com/job_paula-landing/artifacts/0jxgh4ll_IMG_20251201_123526.jpg",
  anmalPaulaFinished:
    "https://customer-assets.emergentagent.com/job_paula-landing/artifacts/cls7ehhc_IMG_20251207_053336.jpg",
  bookCover:
    "https://customer-assets.emergentagent.com/job_paula-landing/artifacts/eio0trx8_Screenshot_20260603_042233_com.canva.editor_edit_142678666404268.jpg",
  shopQrCode:
    "https://customer-assets.emergentagent.com/job_paula-landing/artifacts/62rqyfg5_Rettungssanitterin_Pinguin_Paula_ARHSGBU09X2D.png",
};

export const LINKS = {
  shop:
    "https://rettungssanitaeterin-pinguin-paula.myshopify.com/products/erste-hilfe-ausmalbuch-bleib-cool-das-kannst-auch-du",
  amazon: "https://www.amazon.de",
  radioRsg: "https://www.radiorsg.de",
  email: "fallersimone@googlemail.com",
  emailMailto:
    "mailto:fallersimone@googlemail.com?subject=Pinguin%20Paula%20-%20Anfrage",
  solingerTageblatt:
    "https://www.solinger-tageblatt.de/lokales/solingen/bleib-cool-das-kannst-auch-du-solingerin-veroeffentlicht-ausmalbuch-fuer-erste-hilfe-DMU5Z3XVERFTVCUJ5FA6TZPWCM.html",
  app: "https://notfall-werkstatt.emergent.host",
  appErsteHilfe: "https://notfall-werkstatt.emergent.host/erste-hilfe",
  appSpiele: "https://notfall-werkstatt.emergent.host/spiele",
  appHoerspiele: "https://notfall-werkstatt.emergent.host/hoerspiele",
  appCharta: "https://notfall-werkstatt.emergent.host/charta",
};

export const BRAND = {
  author: "Simone Faller",
  bookTitle: "Bleib cool — das kannst auch Du!",
  bookSubtitle: "Das Erste-Hilfe-Ausmalbuch",
  price: "14,95 €",
  isbn: "978-3-00-084791-2",
  pages: 48,
  copyright: "© 2025 Simone Faller",
  address: {
    street: "Grünewalder Str. 19",
    city: "42657 Solingen",
    country: "Deutschland",
  },
  printer: "HALOR Medienagentur e.K.",
};

// Live-Stats: hier einfach hochzählen, wenn neue Paulas unterwegs sind.
// Werden auf der Förderer-Sektion als animierter Zähler angezeigt.
export const STATS = {
  pluschPaulasPrototyp: 1, // bisher 1 Prototyp
  buecherVerkauft: 6, // verkaufte Bücher (Stand: laufend)
  schulenErreicht: 0, // Schulen/Kindergärten — Zähler hochsetzen wenn Einsätze starten
};
